import {IObjectModelPropertyOptions} from "../../../interfaces/objectModelInterfaces";
import DynamicFieldsElementOptions from "./dynamicFieldsElementOptions";
import ObjectModel from "../../objectModel";
import ObjectModelProperty from "../../objectModelProperties/objectModelProperty";

export default class ObjectModelPropertyOptions extends DynamicFieldsElementOptions<ObjectModelProperty, ObjectModel> implements IObjectModelPropertyOptions {
  getElements: (elementContainer: ObjectModel) => ObjectModelProperty[];
  matcher: (element: ObjectModelProperty) => boolean;
  getElementsDefault(container: ObjectModel): ObjectModelProperty[] {
    return container.objectModelPropertiesArray;
  };
  matcherDefault(element: ObjectModelProperty): boolean {
    return true;
  };

  constructor(config: Partial<IObjectModelPropertyOptions> = {getElements: null, matcher: null}) {
    super(config);
  }

  matchElements(container: ObjectModel, q: string): ObjectModelProperty[] {
    return this.getElements(container).filter(property => property.labelTitleDisplay.toLowerCase().match(q) !== null);
  }
}